import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Hub } from 'aws-amplify/utils';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map, shareReplay } from 'rxjs/operators';

import { GlobalConfig } from './global-config.service';
import { environment } from '../../../environments/environment';

export const XSRF_COOKIE_NAME = 'XSRF-TOKEN';

export const XSRF_HEADER_NAME = 'X-XSRF-TOKEN';

@Injectable({ providedIn: 'root' })
export class CsrfService {

  private pendingRequest: Observable<string | null> | null = null;

  constructor(private http: HttpClient, private config: GlobalConfig) { }

  init(): void {
    this.refresh();

    if (environment.defaultauth !== 'cognito') {
      return;
    }

    Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signedIn' || payload.event === 'signInWithRedirect') {
        this.refresh();
      }
    });
  }

  getToken(): string | null {
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + XSRF_COOKIE_NAME + '=([^;]*)'));

    return match ? decodeURIComponent(match[1]) : null;
  }

  ensureToken(): Observable<string | null> {
    const token = this.getToken();

    return token ? of(token) : this.fetchToken();
  }

  fetchToken(): Observable<string | null> {
    if (this.pendingRequest) {
      return this.pendingRequest;
    }

    this.pendingRequest = this.http
      .get(`${this.config.apiUrl}csrf`, {
        withCredentials: true,
        responseType: 'text',
        headers: { 'x-skip-loading': 'true' },
      })
      .pipe(
        map(() => this.getToken()),
        catchError(error => {
          console.error('CSRF token request failed', error);

          return of(null);
        }),
        finalize(() => { this.pendingRequest = null; }),
        shareReplay({ bufferSize: 1, refCount: false }),
      );

    return this.pendingRequest;
  }

  private refresh(): void {
    this.fetchToken().subscribe();
  }
}
